<div
  *ngIf="isOpen"
  class="relative z-[100]"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  tabindex="-1"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  <div
    [@backdropAnimation]="isOpen"
    class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
  ></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
    >
      <div
        [@modalPanelAnimation]="isOpen"
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
      >
        <!-- Dialog Body -->
        <div class="dialog-body">
          <ng-content></ng-content>
        </div>

        <div>
          <div
            *ngIf="showQuestionGif"
            class="mx-auto flex h-12 w-12 items-center justify-center rounded-full"
          >
            <img
              src="assets/images/question.gif"
              alt="Question gif"
              aria-hidden="true"
            />
          </div>
          <div
            *ngIf="isInfoDialog"
            class="mx-auto flex h-12 w-12 items-center justify-center rounded-full"
          >
            <img
              src="assets/images/svgs/info-attention--yellow.svg"
              alt="Information Icon"
              aria-hidden="true"
            />
          </div>

          <div class="mt-3 sm:mt-5">
            <div id="modal-title" class="mt-2">
              <p
                *ngIf="isHTMLQuestion === false"
                class="text-center text-base font-normal text-mango-gray900"
              >
                {{ description }}
              </p>
              <p
                *ngIf="isHTMLQuestion"
                [innerHTML]="description"
                class="text-base font-normal text-mango-gray900"
              ></p>
            </div>
          </div>
        </div>

        <!-- Dialog Footer -->
        <div class="dialog-footer mt-5 sm:mt-6">
          <div class="flex items-center justify-center gap-5">
            <button
              *ngIf="isDialogLoading === false && showCancelButton === true"
              (click)="closeModal()"
              type="button"
              class="inline-flex w-fit justify-center rounded-lg text-base font-extrabold text-mango"
            >
              Cancel
            </button>

            <div
              [ngClass]="{
                'cursor-not-allowed':
                  isDialogLoading || disableActionButton === true
              }"
            >
              <button
                (click)="clickConfirmAction()"
                [ngClass]="[
                  bgConfirmButton === 'primary' && isDialogLoading === false
                    ? 'bg-mango hover:bg-[#db8b0a] focus-visible:outline-mango'
                    : '',
                  (bgConfirmButton === 'primary' && isDialogLoading) ||
                  (bgConfirmButton === 'primary' && disableActionButton)
                    ? 'pointer-events-none bg-mango-crayolaGold hover:bg-mango-crayolaGold focus-visible:outline-mango-crayolaGold'
                    : '',
                  bgConfirmButton === 'danger' && !isDialogLoading
                    ? ' bg-red-600 hover:bg-red-500 focus-visible:outline-red-600'
                    : '',
                  (bgConfirmButton === 'danger' && isDialogLoading) ||
                  (bgConfirmButton === 'danger' && disableActionButton)
                    ? 'pointer-events-none bg-red-400 hover:bg-red-300 focus-visible:outline-red-400'
                    : ''
                ]"
                class="w-fit rounded-lg px-5 py-2 text-base font-extrabold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                @if (isDialogLoading) {
                  <svg
                    aria-hidden="true"
                    role="status"
                    class="mr-3 inline h-4 w-4 animate-spin text-white"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    ></path>
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  {{ dialogLoadingText ? dialogLoadingText : 'Loading...' }}
                } @else {
                  {{ title }}
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
